import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { UseNotificationManagerReturn } from './hook';

export const {
	Context: StarterDashboardV2PageNotificationManagerContext,
	Provider: StarterDashboardV2PageNotificationManagerContextProvider,
	useContext: useStarterDashboardV2PageNotificationManagerContext,
} = createMandatoryContext<UseNotificationManagerReturn>(undefined, {
	name: 'StarterDashboardV2PageNotificationManagerContext',
	processProviderProps: (props) => ({ ...props.value }),
});

export type StarterDashboardV2PageNotificationManager = ReturnType<
	typeof useStarterDashboardV2PageNotificationManagerContext
>;
